import s from "./index.module.scss";
import Footer from "@/components/Footer/Footer";
import Head from "next/head";
import Container from "@/components/Container/Container";
import Section from "@/components/Section/Section";
import H1 from "@/UI/H1/H1";
import { SITE_NAME, SITE_URL } from "@/utils/consts";
import Header from "@/components/Container/Header/Header";

export default function Rules() {
  return (
    <>
      <Head>
        <title>Правила сервиса {SITE_NAME}</title>
        <meta
          name="description"
          content={`Правила сервиса ${SITE_NAME}. Обмен криптовалюты на наличные по лучшему курсу. Гарантируем конфиденциальность.`}
        />
        <meta name="robots" content="noindex" />
      </Head>

      <Header />
      <div className={s.block}>
        <main>
          <Container>
            <Section>
              <H1>Правила сервиса</H1>
              <div className={s.content}>
                Соглашение, названное Пользовательским соглашением, представляет
                собой электронный договор между Пользователем и сервисом. Оно
                содержит правила, которые регулируют работу на Сайте {SITE_NAME}{" "}
                по адресу {SITE_URL}. Подтверждая свое безоговорочное согласие с
                настоящим Пользовательским соглашением, Пользователь продолжает
                использовать сайт.
                <br />
                <br /> Количество подтверждений для завершения транзакции:
                <br />
                USDT TRC20 — 25 подтверждений.
                <br />
                USDT BEP20 — 40 подтверждений.
                <br />
                USDT ERC20 — 25 подтверждений.
                <br />
                Bitcoin — 4 подтверждения.
                <br />
                Ethereum — 25 подтверждений.
                <br />
                ETH BEP20 — 30 подтверждений.
                <br />
                ETC — 300 подтверждений.
                <br />
                USDC TRC20 — 25 подтверждений.
                <br />
                USDC ERC20 — 25 подтверждений.
                <br />
                USDC BEP20 — 25 подтверждений.
                <br />
                LTC — 15 подтверждений.
                <br />
                <br /> Обращаем внимание Пользователя на следующее:
                <br />
                Пользователь несет ответственность за все возможные риски,
                связанные с использованием Услуг в данном Сервисе, а также с
                транзакциями, связанными с цифровыми активами, валютами и их
                производными. Пользователь осведомлен о том, что данный Сервис
                предназначен исключительно для получения информации о цифровых
                активах, поиска торговых партнеров, проведения переговоров и
                сделок, а также операций с цифровыми активами. Пользователь
                самостоятельно и должным образом должен проверять подлинность,
                легальность и действительность соответствующих цифровых активов
                и/или информации, и несет самостоятельную ответственность за
                любые убытки, возникающие в связи с этим.
                <br />
                <br />
                Изменения в содержании данных Условий могут быть внесены в любое
                время без предварительного уведомления Пользователей. При
                использовании данной Услуги Пользователь соглашается регулярно
                проверять и следить за обновлениями, изменениями и измененным
                содержанием данных Условий. Если Пользователь не согласен с
                такими изменениями, ему следует немедленно прекратить
                использование Сервисов {SITE_NAME}. Продолжение использования
                Услуг {SITE_NAME} Пользователем будет означать его принятие и
                согласие с обновленными Условиями. Использование системы
                транзакций в Интернете сопряжено с определенными рисками,
                включая возможные сбои программного обеспечения, оборудования и
                интернет-соединения. Учитывая, что нам не подвластна надежность
                и доступность Интернета, мы не несем ответственности за
                искажения, задержки и сбои в соединении. Согласно настоящим
                Условиям, {SITE_NAME} не выступает агентом, доверенным лицом или
                представителем Пользователя.
                <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                  <li>
                    1. Термины и определения.
                    <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                      <li>
                        1.1. Сервис “{SITE_NAME}” — платформа для совершения
                        внебиржевых сделок.
                      </li>
                      <li>
                        1.2. Пользователь — любое дееспособное Лицо, достигшее
                        18-летнего возраста, оставившее заявку на обмен на Сайте
                        и согласившееся с Правилами и Условиями настоящего
                        Соглашения.
                      </li>
                      <li>
                        1.3. Услуги сервиса — оказание содействия в проведении
                        операций между физическими лицами по обмену криптовалют,
                        а также иные услуги, информация о которых размещена на
                        сайте Сервиса.
                      </li>
                      <li>
                        1.4. Персональные данные – информация, которая
                        идентифицирует человека:
                        <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                          <li>
                            – имя
                            <br />– адрес
                            <br />– адрес электронной почты
                            <br />– банковские реквизиты
                            <br />– иные данные, в соответствии с настоящей
                            Политикой.
                            <br />
                            Термин «Персональные данные» не включает анонимные
                            и/или сводные данные, которые не дают возможности
                            идентифицировать конкретного Пользователя.
                          </li>
                        </ul>
                      </li>
                      <li>
                        1.5. Соглашение – настоящее Пользовательское соглашение
                        (Условия) и его неотъемлемые части с учетом всех
                        дополнений и/или изменений, которые могут быть внесены в
                        порядке, определяемом их условиями.
                      </li>
                      <li>
                        1.6. Сайт — совокупность информации, текстов,
                        графических элементов, дизайна, изображений, фото и
                        видеоматериалов и других результатов интеллектуальной
                        деятельности, а также набор компьютерных программ,
                        содержащихся в информационной системе, обеспечивающих
                        доступность такой информации по адресу: {SITE_URL},
                        включая любые субдомены, и, если домен или материал
                        Сайта должен быть по какой-либо причине изменен, он
                        включает Сайт после любых таких изменений.
                      </li>
                      <li>
                        1.7. Заявка – внесение Пользователем предложения на
                        покупку или продажу криптовалюты с использованием Услуг,
                        предоставляемых Сервисом.
                      </li>
                      <li>
                        1.8. Платежная система — программно-аппаратный продукт,
                        разработанный третьей стороной и представляющий собой
                        механизм реализации учета денежных обязательств и
                        организации взаиморасчетов между своими Пользователями.
                      </li>
                      <li>
                        1.9. KYC & AML процедуры – «Know Your Customer» (знай
                        своего клиента) – проверка персональных данных клиента и
                        «Anti-Money Laundering» – проверка цифровых
                        активов/денежных средств Пользователя в целях
                        противодействия отмыванию средств.
                      </li>
                      <li>
                        {` 1.10. Термин цифровые активы" (в дальнейшем также называемые
                            "криптовалюта" или "цифровая валюта") относится к зашифрованным или
                            цифровым токенам или валютам с определенной стоимостью, которые основаны
                            на технологии блокчейн и криптографии. Учет внутренних единиц этих
                            активов осуществляется децентрализованной системой, которая
                            функционирует полностью автоматически и не имеет внутреннего или
                            внешнего администратора или аналога.`}
                      </li>
                    </ul>
                  </li>
                  <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                    2. Основные положения
                    <li>
                      <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                        <li>
                          2.1. Перед использованием любой из Услуг,
                          предоставляемых {SITE_NAME}, Пользователь должен
                          внимательно прочитать настоящие Условия. Если
                          Пользователь не согласен с настоящими Условиями и/или
                          изменениями к ним, он обязан незамедлительно
                          прекратить использование Услуг, представленных на
                          Сайте.
                        </li>
                        <li>
                          2.3. Используя Услуги, предоставляемые Сервисом{" "}
                          {SITE_NAME}, Пользователь заявляет и гарантирует, что:
                          <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                            <li>
                              – Пользователь достиг возраста 18 лет. Кроме того,
                              Пользователь должен обладать достаточной
                              дееспособностью для принятия настоящих Условий,
                              заключения договоров, исполнения договоров,
                              совершения сделок с цифровыми активами через этот
                              Сервис;
                              <br />– Используемые Пользователем цифровые
                              активы/денежные средства получены законным путем;
                              <br />– Соглашается нести полную ответственность
                              за любые возможные последствия совершения сделок;
                              <br />– Соглашается соблюдать требования
                              применимого законодательства и гарантирует, что
                              совершение Пользователем сделок не преследует
                              какие-либо незаконные цели;
                              <br />– Пользователь не находится под влиянием
                              третьих лиц, все действия его добровольны и
                              обдуманны.
                            </li>
                          </ul>
                        </li>
                        <li>
                          2.4. При формировании заявки на услугу Пользователь
                          обязуется указать свои личные банковские
                          реквизиты/адреса криптокошельков для получения
                          денежных средств/цифровых активов по сделке.
                        </li>
                        <li>
                          2.5. При совершении платежа в рамках сделки,
                          Пользователь обязуется использовать только свои личные
                          банковские счета или счета платежных систем для
                          перевода денежных средств. При совершении сделки с
                          цифровыми активами, Пользователь подтверждает, что
                          используемые им криптокошельки или аккаунты на
                          сторонних централизованных платформах принадлежат
                          исключительно ему, и у третьих лиц нет доступа к его
                          криптокошельку или аккаунту на сторонних
                          централизованных платформах. В случае, если
                          Пользователь понесет финансовые потери из-за
                          использования криптокошельков, банковских счетов или
                          счетов платежных систем, не принадлежащих ему лично,
                          он несет полную ответственность за эти финансовые
                          потери.
                        </li>
                      </ul>
                    </li>
                  </ul>
                  <li>
                    3. Услуги
                    <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                      <li>
                        3.1. Заказ услуг Сервиса и получение информации о ходе
                        выполнения сделки Пользователем производятся
                        исключительно при помощи контактов с представителем
                        Сервиса, размещенных на Сайте.
                      </li>
                      <li>
                        3.2. Сервис предлагает свои услуги согласно
                        установленному внутреннему расписанию работы сервиса.
                        Сервис принимает Заявки круглосуточно. Заявки,
                        осуществляемые сервисом в полуавтоматическом режиме,
                        могут производиться до 24 часов. Заявки, осуществляемые
                        сервисом в ручном режиме, могут производиться до 36
                        часов. Сервис не несет ответственности за просрочку
                        обработки заявки, вызванной техническими сбоями, включая
                        сбоями в сети блокчейна.
                      </li>
                      <li>
                        3.3 Вопросы и претензии по заявкам принимаются в течение
                        24 часов с момента оформления Заявки. По истечению 24
                        часов заявки на обмен презюмируются выполненными
                        надлежащим образом.
                      </li>
                      <li>
                        3.4. В случае любых подозрительных действий со стороны
                        Пользователя, а также в случае использования
                        Пользователем подозрительных активов, сервис может
                        задержать выплату и потребовать пройти дополнительную
                        верификацию личности и провести внутренний анализ
                        используемых Пользователем средств.
                      </li>
                      <li>
                        3.5. Сервис оставляет за собой право отказать в
                        осуществлении Услуги в одностороннем порядке на свое
                        усмотрение.
                      </li>
                      <li>
                        3.6. В случае обнаружения подозрительной активности в
                        процессе оформления Заявки Пользователем, Сервис, во
                        избежание ущерба, вправе приостанавливать выполнение
                        таких операций до выяснения причин подобной активности.
                      </li>
                      <li>
                        3.7. В случае отправки Пользователю большего количества
                        цифровых активов/денежных средств, чем следовало из
                        конкретной Заявки, Пользователь обязуется
                        незамедлительно сообщить об этом Сервису. Пользователь
                        обязуется вернуть разницу отправленных цифровых
                        активов/денежных средств в течение 24 часов с момента
                        получения таковых. В случае невозврата излишне
                        отправленных Цифровых активов/денежных средств, Сервис
                        вправе ограничить предоставление Услуг Пользователю и
                        обратиться в правоохранительные органы.
                      </li>
                      <li>
                        3.8. Если Пользователь оплатил заявку, но по каким-либо
                        обстоятельствам желает её отменить, то Сервис обязуется
                        обеспечить возврат оплаченной заявки за вычетом расходов
                        на банковские комиссии/комиссии сети блокчейн. При
                        отмене Пользователем заявки после её оплаты, Сервис
                        вправе удержать комиссию в размере 2%, исчисляемую из
                        суммы Заявки. При этом, в случае оплаты заявки в
                        криптовалюте, Пользователь берет риск снижения биржевого
                        курса криптовалюты на себя. Пользователю может быть
                        возвращена криптовалюта по биржевому курсу (курс
                        криптовалютной биржи Binance) конкретной криптовалюты на
                        сумму фиатной валюты исходя из условий конкретной
                        заявки, в любой момент дня, в течение которого подлежит
                        возврат. В случае, если Пользователь желает отменить
                        заявку, оплаченную денежными средствами, Пользователь
                        принимает на себя риск изменения биржевого курса
                        криптовалюты. Пользователю могут быть возвращены
                        денежные средства с учетом изменения биржевого курса
                        конкретной криптовалюты (курс криптовалютной биржи
                        Binance) исходя из Заявки.
                      </li>
                      <li>
                        3.9. Курс обмена криптовалюты волатилен и может меняться в зависимости от суммы обмена и изменений биржевого курса (курс криптовалютной биржи Binance). Актуальный курс обмена согласовывается с сотрудником сервиса при проведении сделки.
                      </li>
                      <li>
                        3.10. Сервис вправе отменить созданную Пользователем
                        Заявку на предоставления Услуг Сервиса, если
                        Пользователь не произвел оплату по истечении 30
                        (тридцати) минут с момента создания такой заявки.
                      </li>
                      <li>
                        3.11. Сервис не принимает средства отправленные через
                        смарт-контракты поскольку использует в работе биржевые
                        кошельки. Не отправляйте средства сервису напрямую через
                        смарт-контракты, поскольку они могут быть утеряны
                        навсегда. В случае отправки средств через смарт-контракт
                        Пользователь принимает все риски на себя.
                      </li>
                    </ul>
                  </li>
                  <li>
                    4. Права и обязанности
                    <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                      4.1. В случае получения запроса уполномоченных
                      правоохранительных органов касательно операции
                      Пользователя, Сервис оставляет за собой право в любой
                      момент приостановить или отменить выполняющуюся операцию
                      на неограниченный срок. При этом, в случае запроса, Сервис
                      оставляет за собой право предоставить уполномоченным
                      правоохранительным органам имеющуюся информацию о
                      Пользователе. 4.2. Сервис оставляет за собой право в любой
                      момент приостановить или отменить операцию Пользователя с
                      возвратом средств, без учета возможных убытков или
                      расходов Сервиса в случае нарушения Пользователем
                      настоящего Соглашения. 4.3. Сервис вправе запрашивать у
                      Пользователя персональные данные в целях обработки и
                      оформления Заявки для предоставления Услуг Сервиса, а
                      также в целях направления Пользователю информации,
                      касающейся предоставления Сервисом Услуг и рассмотрения
                      претензий и обращений Пользователя. Оставляя Заявку на
                      Сайте, Пользователь дает свое безоговорочное согласие на
                      обработку персональных данных. 4.4 Персональные данные
                      включают в себя: 4.5. Под обработкой персональных данных
                      понимается сбор, запись, систематизация, накопление,
                      уточнение (обновление, изменение), извлечение,
                      использование с целью осуществления операции,
                      обезличивание, блокирование, удаление, уничтожение
                      персональных данных. Обработка вышеуказанных персональных
                      данных будет осуществляться как с использованием средств
                      автоматизации, так и без их использования (смешанная
                      обработка персональных данных). 4.6. Сервис вправе
                      проводить KYC и AML процедуры по своему усмотрению, в
                      случае наличия подозрительной активности в действиях
                      Пользователя, а также в случаях, когда Сервисом получен
                      запрос от уполномоченных правоохранительных органов по
                      конкретной Заявке. 4.7. При проведении AML процедур,
                      Сервис вправе использовать специальные сторонние
                      сервисы/программы для таких проверок, например,
                      https://crystalblockchain.com/. 4.8. Исполнитель в праве
                      производить AML проверку активов, поступивших от
                      Заказчика. При превышении допустимого уровня риска (по
                      усмотрению Сервиса) транзакция может быть заблокирована до
                      прохождения верификации Пользователем, после чего Сервисом
                      может быть осуществлен возврат. Возврат средств
                      осуществляется за вычетом комиссии платежной системы за
                      перевод, за вычетом комиссии сети или биржи и за вычетом
                      издержек Сервиса. Возврат может занимать от 1 до 30 дней.
                    </ul>
                  </li>
                  <li>
                    5. Обстоятельства непреодолимой силы
                    <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                      <li>
                        5.1. Пользователь или Сервис не несут ответственности
                        друг перед другом за невыполнение обязательств,
                        связанных с оказанием Сервисом услуг по обмену,
                        вызванное обстоятельствами, возникшими помимо воли и
                        желания сторон, которые нельзя было предвидеть или
                        избежать, включая объявленную или фактическую войну,
                        гражданские волнения, эпидемии, землетрясения,
                        наводнения, пожары и другие стихийные бедствия, действия
                        органов власти и прочие непреодолимые обстоятельства и
                        не могут заявлять ни о каких убытках или ущербе,
                        возникших из-за таких обстоятельств.
                      </li>
                      <li>
                        5.2. Сторона, которая не исполняет свое обязательство
                        вследствие действия непреодолимой силы, должна известить
                        другую Сторону о препятствии и его влиянии на исполнение
                        обязательств без промедления, но не позднее 3 (трех)
                        календарных дней с момента наступления указанных
                        обстоятельств.
                      </li>
                      <li>
                        5.3. Сторона, не известившая другую Сторону о
                        невозможности исполнения своих обязательств по
                        настоящему договору, теряет право ссылаться на такую
                        невозможность.
                      </li>
                    </ul>
                  </li>
                  <li>
                    6. Ответственность
                    <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                      <li>
                        6.1. Пользователь несет полную ответственность за все
                        действия, связанные с использованием Услуг, а также за
                        безопасность собственных компьютерных систем и
                        технического оборудования.
                      </li>
                      <li>
                        6.2. Пользователь признает и принимает, что любая
                        транзакция, совершенная в blockchain, необратима,
                        Пользователь несет полную ответственность за
                        представление правильной информации о кошельке
                        получателя для передачи Цифровых активов при
                        использовании Услуг Сервиса, а также за предоставление
                        правильной информации о банковских реквизитах
                        получателя.
                      </li>
                      <li>
                        6.3. Пользователь несет полную ответственность за
                        использование Услуг, собственные действия при
                        использовании Сервиса, проводимые им операции, сделки,
                        транзакции, предоставленную информацию и документацию.
                      </li>
                      <li>
                        6.4. Сервис не несет ответственность в случае блокировки
                        банковских счетов/счета в Платежной системе Пользователя
                        в результате внутренних проверок указанных финансовых
                        учреждений, при получении Пользователем денежных средств
                        в результате использования Услуг Сервиса
                      </li>
                    </ul>
                  </li>
                  <li>
                    7. Заключительные положения
                    <ul className="flex flex-col gap-2 pl-2 pt-4 md:pl-4">
                      <li>
                        7.1. Пользователь должен участвовать в сделках и
                        транзакциях только в том случае, если он имеет полное
                        представление о работе blockchain и полностью понимает
                        риски, связанные с криптовалютами.
                      </li>
                      <li>
                        7.2. Все претензии и обращения Пользователя направляются
                        по контактным данным Сервиса, указанных на Сайте. Срок
                        рассмотрения претензии составляет 7 рабочих дней с
                        момента её получения.
                      </li>
                      <li>
                        7.3. Услуги, предоставляемые Сервисом, могут быть
                        законодательно запрещены в некоторых юрисдикциях.
                        Принимая условия использования услуг сервиса Сервисом,
                        Пользователь подтверждает, что не является резидентом
                        подобной юрисдикции.
                      </li>
                      <li>
                        7.4. Обратите внимание, что при обмене на сумму менее 400 000 рублей (или эквивалент этой суммы в другой валюте) взимается  дополнительная комиссия. Подробности уточняйте у менеджера.
                      </li>
                      {/* <li>
                        7.4 На основе внутренних бизнес процессов Сервис имеет
                        право отказать в сделке с полным возвратом средств, за
                        исключением комиссии сети на возврат или иной комиссии
                        до 20% без объяснения причин.
                      </li> */}
                    </ul>
                  </li>
                </ul>
              </div>
            </Section>
          </Container>
        </main>
      </div>
      <Footer />
    </>
  );
}
